import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'



interface Props {
    children: React.ReactNode
    initialWidth?: number | string
    targetWidth: number | string
    duration?: number
    delay?: number 
    ease?: string
}

const WidthAnimation: React.FC<Props> = ({
    children,
    initialWidth = 'auto',
    targetWidth,
    duration = 0.4,
    delay = 0,
    ease = 'power3.out'
}) => {


    const elementRef = useRef<HTMLElement>(null)
    const prevWidthRef = useRef<string| number>(initialWidth)
    useEffect(() => {
        const animationElement = elementRef.current
        if (!animationElement) return


        if (targetWidth !== prevWidthRef.current) {
            const timeline = gsap.timeline({
                paused: true
            })

            timeline.to(animationElement, {
                width: targetWidth,
                duration: duration,
                delay: delay,
                ease: ease
            })

            timeline.play()

            prevWidthRef.current = targetWidth


        }
        return ():void => {
            gsap.killTweensOf(animationElement)
        }

    }, [targetWidth, duration, delay, ease])




    return (
        <div
            ref={elementRef}
            style={{
                width: initialWidth,
                overflow: 'hidden'
            }}
            
        >
            {children}
        </div>

    )
}
export default WidthAnimation